module.exports = __webpack_public_path__ + "static/img/openbrower.3f1d707b.jpg";